export const environment = {
  production: false,
  apiUrl: 'https://apigw-dev.mzic.io',
  imagesUrl: 'https://revelatorstage.blob.core.windows.net/images',
};
